import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Battitore** (manuale V1, rr. 1364-1371).
 *
 * Conosce il territorio, sa fiutare una preda. È un "Ranger povero": non ha
 * la familiarità del Ranger con creature strane, ma copre il ruolo di
 * Apripista nei viaggi.
 *
 * **Pattern «sostituisce»**: il Rango 3 sostituisce il Rango 1 (manuale
 * r. 1371). Quando il Battitore raggiunge R3, perde l'effetto di R1.
 */
export const battitore: FollowerAbility = {
  id: 'battitore',
  label: 'Battitore',
  description:
    'Conosce il territorio (locande, taverne e birrerie clandestine incluse) e sa fiutare una preda, ma non ha la familiarità di un Ranger con creature strane e posti ancora più strani.',
  ranks: [
    {
      rank: 1,
      trigger:
        'Quando assegni a un Battitore il ruolo di Apripista per *intraprendere un viaggio pericoloso*',
      description:
        'Considera di aver ottenuto un risultato di 7-9 per tale ruolo senza bisogno di tirare i dadi.',
    },
    {
      rank: 2,
      trigger: 'Quando un Battitore segue le tracce di una creatura',
      description:
        'Ti guida fino al prossimo cambiamento significativo (direzione, terreno, meteo o modalità di spostamento). Dopo che ha usato questa mossa, il Battitore non può usarla di nuovo finché non vi *accampate*.',
    },
    {
      rank: 3,
      trigger:
        'Quando assegni a un Battitore il ruolo di Apripista per *intraprendere un viaggio pericoloso*',
      description:
        'Considera di aver ottenuto un risultato di 10+ per tale ruolo senza dover tirare i dadi.',
      replacesRank: 1,
    },
  ],
};
